import { Language } from "@altify/utils";

export function getBrowserLanguage() {
    return languageFromLocale(navigator.language);
}

function languageFromLocale(locale: string) {
    if (!locale) return null;
    return locale.split('-')[0].toLowerCase() as Language;
}